import type { DateRangePreset } from "../../../components/Filters/PresetDateRangeFilter.tsx"
import { type ProjectFilters } from "./projects.types.ts"

export const projectsSliceName = "projects"

interface BaseFilterField {
  key: keyof ProjectFilters
  label: string
  placeholder?: string
}

export type FilterField =
  | (BaseFilterField & { type?: "select" | "multiselect" })
  | (BaseFilterField & { type: "text" })
  | (BaseFilterField & { type: "daterange"; endKey: keyof ProjectFilters })
  | (BaseFilterField & {
      type: "presetrange"
      endKey: keyof ProjectFilters
      presetKey: keyof ProjectFilters
      presets: readonly DateRangePreset[]
      allTimeLabel: string
      customLabel: string
    })

/** Every param the field owns — a range writes two, `key` being its lower
 *  bound; a preset range writes a preset key as well. */
export const fieldKeys = (field: FilterField): (keyof ProjectFilters)[] => {
  if (field.type === "presetrange")
    return [field.presetKey, field.key, field.endKey]
  if (field.type === "daterange") return [field.key, field.endKey]
  return [field.key]
}

export const countActiveFilters = (
  filters: ProjectFilters,
  filterFields: FilterField[]
): number =>
  filterFields.filter((field) =>
    fieldKeys(field).some((key) => {
      const value = filters[key]
      if (Array.isArray(value)) return value.length > 0
      return value !== null && value !== undefined
    })
  ).length

// A filter value is typed as the union of every param; some fields hold text.
export const asString = (value: ProjectFilters[keyof ProjectFilters]) =>
  typeof value === "string" ? value : null
